import React, { useEffect, useState, useRef } from "react";
import growthicon from "../../../assets/img/GG210.png";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { BiArrowBack } from "react-icons/bi";
import { Input } from "reactstrap";
import * as yup from "yup";
import { Formik } from "formik";
import axios from "axios";
import { API_AUTH } from "../../../utils/config";
import Navigation from "../../../common/Navigation";
import {
  useLocation,
  useHistory,
  BrowserRouter,
} from "react-router-dom";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const ForPass = (props) => {
  const [hidden, setHidden] = useState(true);

  let history = useHistory();

  const passValidationSchema = yup.object().shape({
    password: yup
      .string()
      .matches(
        "^(?=.*\\d)(?=.*[!@$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$",
        "Password must be alpha numeric and 8 character  in length "
      )
      .min(8, ({ min }) => `Password must be at least ${min} characters`)
      .required("Password is required")
      .max(20, "Password must be below 9 characters"),
  });
  const textInput = useRef(null);

  useEffect(() => {
    checkingCurrentUser();
    textInput.current.focus();
  });

  const checkingCurrentUser = () => {
    axios
      .get(`${API_AUTH}/v1/api/auth/isLoggedIn`, { withCredentials: true })
      .then((response) => {
        if (response.data) {
          history.push({
            pathname: "/dashboard",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const toggleShow = () => {
    setHidden(!hidden);
  };

  let query = useQuery();

  const handleSubmit = async (password) => {
    let ssdic = query.get("ssdic");
    let ssoci = query.get("ssoci");
    let body = {
      password,

      ssdic,
      ssoci,
    };

    await axios
      .post(`${API_AUTH}/v1/api/auth/reset-password`, body, {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.ok) {
          history.push({
            pathname: "/signin",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <Navigation show="true" />
      <Formik
        validationSchema={passValidationSchema}
        initialValues={{ password: "" }}
        onSubmit={(values) => handleSubmit(values.password)}
      >
        {({
          handleChange,
          handleSubmit,
          values,
          errors,
          touched,
          isValid,
          validationSchema,
        }) => (
          <>
            <div className="sign-container">
              <div className="child-signcontainer">
                <Link
                  style={{
                    color: "#005500",
                    marginLeft: "30px",
                    marginTop: "30px",
                  }}
                  to="/forget_password"
                >
                  {" "}
                  <h4>
                    {" "}
                    <BiArrowBack />{" "}
                  </h4>
                </Link>
                <div className="child-firstcontainer">
                  <img
                    style={{ marginRight: "20px" }}
                    src={growthicon}
                    height="60"
                    width="170"
                    alt="PION global"
                    id="logo"
                  ></img>
                </div>

                <div className="child-secondcontainer">
                  <span style={{ fontWeight: 500, fontSize: "20px" }}>
                    Reset Password
                  </span>

                  <div className="sign-form">
                    <input
                      type={hidden ? "password" : "text"}
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      name="password"
                      ref={textInput}
                      placeholder="Reset Password"
                      onChange={handleChange("password")}
                      value={values.password}
                      autoComplete="off"
                      required
                    ></input>
                    {errors.password && touched.password && (
                      <span style={{ fontSize: "14px", color: "red" }}>
                        {errors.password}
                      </span>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",

                      marginTop: "-10px",
                    }}
                  >
                    <Input type="checkbox" onClick={toggleShow} />
                    <span style={{ fontSize: "14px", marginLeft: "8px" }}>
                      Show Password
                    </span>
                  </div>
                </div>
                <div
                  className="log-button"
                  onClick={() => {
                    handleSubmit();
                  }}
                  disabled={!isValid}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      background: "#005500",
                    }}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
      </Formik>
    </div>
  );
};

export default ForPass;
